<template>
    {{ warehouse }}
</template>
<script setup>
import { computed } from "vue";
import _ from "lodash";
import config from "@/config";

const props = defineProps({
    code: {
        type: String,
        required: true,
    },
});

const warehouse = computed(() => {
    return _.find(config.warehouses, { code: props.code })?.state;
});
</script>
